// Vue.js
import Vue from 'vue'

// Main component
import App from './App.vue'

// VueFire
import VueFire from 'vuefire'

// Router
import router from './router'

// Store
import store from './store'

// Vuetify (Vue.js frontend Framework)
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// Codemirror plugin for Vue.js
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'

// Vue plugins activation
Vue.use(VueFire)
Vue.use(Vuetify, { theme: {
  primary: '#424242',
  secondary: '#acacac',
  accent: '#0071bc',
  extra: '#29abe2'
} })
Vue.use(VueCodemirror, { options: { theme: 'base16-dark' }})

// Production tips
Vue.config.productionTip = false

// Vue app instance
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
